export default function ($scope, Restangular, $stateParams, NgAdminConfiguration) {
    let admin = NgAdminConfiguration();
    let DateField = require('admin-config/lib/Field/DateField');

    $scope.label = "Game";
    $scope.id = $stateParams.id;
    $scope.entity = admin.getEntity('game');
    $scope.entry = {};
    $scope.configs = {};
    $scope.date = new DateField('age');

    Restangular
        .one('game', $stateParams.id)
        .get()
        .then(data => {
            data = data.data ? data.data : data;

            $scope.entry = {
                entity: 'game',
                id: data.id
            }
        });
    Restangular
        .all('configs')
        .getList({_filters: '{"game":"' + $stateParams.id + '"}', _sortDir: "ASC", _sortField: "variable"})
        .then(data => {
            data = data.data ? data.data : data;

            $scope.configs = data;
            $scope.apply();
        });


    $scope.apply = function () {
        Restangular
            .one('config/test/game', $stateParams.id)
            .get({age: $scope.age})
            .then(data => {
                data = data.data ? data.data : data;

                for(let i in $scope.configs){
                    let id = $scope.configs[i].variable.id;
                    $scope.configs[i].initial_value = data.config[id].config;
                }
            });
    };

    $scope.range = function(min, max, step){
        step = step || 1;
        let input = [];
        for (let i = min; i <= max; i += step) input.push(i);
        return input;
    };

    $scope.columns = 0;

    $scope.run = function(index, column_update, callback){

        let params = {
            finished: $scope.configs[index] ? $scope.configs[index].finished : false,
            returnParams: {},
            activityValues: {}
        };

        for(let i in $scope.configs){
            let data, activity = null;

            if(!$scope.configs[i] || typeof $scope.configs[i] !== 'object' || !('variable' in $scope.configs[i]))
                continue;

            if(index > 0)
                activity = $scope.configs[i].return[index-1];
            else
                activity = $scope.configs[i].initial_value;

            if($scope.configs[i].data && $scope.configs[i].data[index])
                data = $scope.configs[i].data[index];
            else
                data = activity;

            params.activityValues[$scope.configs[i].variable.id] = activity;
            params.returnParams[$scope.configs[i].variable.id] = data;
        }

        Restangular
            .one('config/test/game', $stateParams.id)
            .get({activity: params})
            .then(data => {
                data = data.data ? data.data : data;

                for(let i in $scope.configs){
                    if(!$scope.configs[i] || typeof $scope.configs[i] !== 'object' || !('variable' in $scope.configs[i]))
                        continue;

                    if(!$scope.configs[i].return)
                        $scope.configs[i].return = [];

                    $scope.configs[i].return[column_update != null ? column_update : $scope.columns] = data.config[$scope.configs[i].variable.id].config;
                }

                if(column_update == null)
                    $scope.columns++;

                if(callback)
                    callback();
            });

    };
    $scope.reset = function(index){
        $scope.run(index, index);
    }

    $scope.reset_index = 0;
    $scope.reset_all = function(){

        $scope.run($scope.reset_index, $scope.reset_index, function(){
            if($scope.reset_index < $scope.columns){
                $scope.reset_all();
                $scope.reset_index++;
            }else{
                $scope.reset_index = 0;
            }
        });
    }

    $scope.delete_all = function(){

        for(let i in $scope.configs){
            let data, activity = null;

            if(!$scope.configs[i] || typeof $scope.configs[i] !== 'object' || !('variable' in $scope.configs[i]))
                continue;

            delete $scope.configs[i].return;
            delete $scope.configs[i].data;

        }
        $scope.columns = 0;
    }
};


/** WEBPACK FOOTER **
 ** ./js/theme/game/test/controller.js
 **/